module.exports = __webpack_public_path__ + "static/8-after.350f0b89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-size/8-after.jpg
// module id = 445
// module chunks = 221374088121123